import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Grid, Cell } from "react-md";
import { EmployeeDetails, TimeLogs } from "components/User";
import { MCard, MSpinner } from "components/Shared";
import EmployeeMappings from "components/EmployeeCustomerSurveyTypes/EmployeeMappings";
import { CaseTimeLogWorkTypeEnum, EmployeeListDto } from "interfaces/Mueller.Business.Models";
import { getTimeClockByPayPeriod, getActiveClock, clockIn, clockOut, addTimeClock, deleteTimeClock, updateTimeClock } from "actions/account";
import { addCaseTimeLog, deleteCaseTimeLog, getCaseTimeLogByUserPayPeriod, updateCaseTimeLog } from "actions/casetimelog";
import { ClockInOutCard, ProductionTimeCard } from "components/Shared/TimeLogs";
import { getPayPeriodList } from "actions/casetimelog";
import EmployeeTEAM from "components/Employee/EmployeeTEAM";
import { MANAGEMENT_CALENDAR_EDIT } from 'typeConstants/rights';
import { userHasRight } from "selectors/rights";
import EmployeeCalendar from "components/Employee/EmployeeCalendar.tsx";


interface Props {
  verticalDisplay: boolean,
  employeeId: number,
  selectedUserIndex: number,
  // Redux
  fetchingSchedulingUsers: boolean,
  schedulingUsers: EmployeeListDto[],

  updatingUser: boolean;
  isFetchingActiveClock: boolean;
  activeClock: object;
  getActiveClock: Function;
  clockIn: Function;
  clockOut: Function;
  getCaseTimeLogByUserPayPeriod: Function;
  getPayPeriodList: Function;
  isFetchingTimeLogs: boolean;
  timeLogs: Array<any>;
  isFetchingPayPeriods: boolean;
  payPeriods: Array<any>;
  timeClockByPayPeriod: Array<any>;
  isFetchingTimeClockByPayPeriod: boolean;
  getTimeClockByPayPeriod: Function;
  isFetchingTimeLogByDaySummary: boolean;

  addTimeClock: Function,
  deleteTimeClock: Function,
  updateTimeClock: Function,
  isAddingTimeClock: boolean,
  isDeletingTimeClock: boolean,
  isUpdatingTimeClock: boolean,
  isUpdatingTimeLogs: boolean,
  isDeletingTimeLogs: boolean,
  isAddingTimeLogs: boolean,
  updateCaseTimeLog: Function,
  deleteCaseTimeLog: Function,
  addCaseTimeLog: Function,

  canEditCalendarAsManager: boolean,
};

const SchedulingAssistantProfile = (props: Props) => {
  const mounted = useRef(true);
  const [selectedPayPeriodIndex, setSelectedPayPeriodIndex] = useState(0);

  useEffect(() => {
    return () => { mounted.current = false; };
  }, []);

  const cellWidth = props.verticalDisplay ? 12 : 4;

  if (props.fetchingSchedulingUsers) {
    return (<MSpinner/>);
  }

  const user = props.schedulingUsers[props.selectedUserIndex];

  const { fromDate } = props.payPeriods[selectedPayPeriodIndex];
  const { toDate } = props.payPeriods[selectedPayPeriodIndex];
  const startDate = new Date(fromDate.year, fromDate.month - 1, fromDate.day);
  const endDate = new Date(toDate.year, toDate.month - 1, toDate.day);

  return (
    <Grid className="md-grid-cards">
      <Cell size={cellWidth}>
        <EmployeeDetails employeeId={user.employeeId} />
      </Cell>
      <Cell size={cellWidth}>
        <EmployeeTEAM internetUserId={user.internetUserId} />
      </Cell>
      <Cell size={cellWidth}>
        <EmployeeMappings employeeId={user.employeeId} />
      </Cell>
      <MCard
        title="Employee Calendar"
        cellWidth={cellWidth}
        fields={[
          {
            key: "calendar", 
            control: (
              <EmployeeCalendar 
                employeeId={user.employeeId}
                readOnly={!props.canEditCalendarAsManager}
                allowManagementEdit={props.canEditCalendarAsManager}
              />)
          }]}
      />            
    </Grid>);
};

const mapStateToProps = state => ({
  fetchingSchedulingUsers: state.employee.fetchingSchedulingUsers,
  schedulingUsers: state.employee.schedulingUsers,

  updatingUser: state.user.updatingUser,
  isFetchingActiveClock: state.user.isFetchingActiveClock,
  activeClock: state.user.activeClock,
  isFetchingTimeLogs: state.caseTimeLog.isFetchingTimeLogs,
  timeLogs: state.caseTimeLog.timeLogs,
  isFetchingPayPeriods: state.caseTimeLog.isFetchingPayPeriods,
  payPeriods: state.caseTimeLog.payPeriods,
  timeClockByPayPeriod: state.user.timeClockByPayPeriod,
  isFetchingTimeClockByPayPeriod: state.user.isFetchingTimeClockByPayPeriod,
  isFetchingTimeLogByDaySummary: state.qualityAssurance.isFetchingTimeLogByDaySummary,
  isAddingTimeClock: state.user.isAddingTimeClock,
  isDeletingTimeClock: state.user.isDeletingTimeClock,
  isUpdatingTimeClock: state.user.isUpdatingTimeClock,

  isUpdatingTimeLogs: state.caseTimeLog.isUpdatingTimeLogs,
  isDeletingTimeLogs: state.caseTimeLog.isDeletingTimeLogs,
  isAddingTimeLogs: state.caseTimeLog.fetching,

  canEditCalendarAsManager: userHasRight(MANAGEMENT_CALENDAR_EDIT)(state),
});

const mapDispatchToProps = dispatch => ({
  getActiveClock(timeZoneOffset) {
    dispatch(getActiveClock(timeZoneOffset));
  },
  clockIn(timeZoneOffset) {
    dispatch(clockIn(timeZoneOffset));
  },
  clockOut(timeZoneOffset) {
    dispatch(clockOut(timeZoneOffset));
  },
  getCaseTimeLogByUserPayPeriod(internetUserId, payPeriodId) {
    dispatch(getCaseTimeLogByUserPayPeriod(internetUserId, payPeriodId));
  },
  getPayPeriodList() {
    dispatch(getPayPeriodList());
  },
  getTimeClockByPayPeriod(internetUserId, payPeriodId) {
    dispatch(getTimeClockByPayPeriod(internetUserId, payPeriodId));
  },
  addTimeClock(internetUserId, dto) {
    dispatch(addTimeClock(internetUserId, dto));
  },
  deleteTimeClock(id) {
    dispatch(deleteTimeClock(id));
  },
  updateTimeClock(id, clockIn, clockOut) {
    dispatch(updateTimeClock(id, clockIn, clockOut));
  },
  updateCaseTimeLog(updatedCaseTimeLog, updateTimeLogFunc) {
    dispatch(updateCaseTimeLog(updatedCaseTimeLog, updateTimeLogFunc));
  },
  deleteCaseTimeLog(id) {
    dispatch(deleteCaseTimeLog(id));
  },
  addCaseTimeLog(dto) {
    dispatch(addCaseTimeLog(dto));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SchedulingAssistantProfile);
